import * as React from 'react'
// components
import { DrawerModal } from 'components/UI'
// view components
import ReviewDetails from './components/ReviewDetails'
import ObjectiveDetails from 'components/Modals/CreateReviewModal/components/ObjectiveDetails'
import ActionDetails from 'components/Modals/CreateReviewModal/components/ActionDetails'
import KPIDetails from 'components/Modals/CreateReviewModal/components/KPIDetails'
import PlanDetailsContainer from 'containers/Plan/Details'
// views
import { EntityDescription, Header, IconWrapper, ReviewDate, RightSidebar, UpdateIndicator, Wrapper } from './views'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { ENTITIES, Modals } from 'constants/index'
// themes
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// context
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'
// utils
import get from 'lodash/get'
import moment from 'moment'
import { getEntityDescription } from 'utils/reviews'

const PAPER_PROPS = {
  style: {
    top: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  }
}

const WRAPPER_STYLES = { position: 'fixed' as any }

const CreateReviewDrawer: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.REVIEW_CREATE_MODAL })

  const { review, entity, isReviewUpdate, handleCloseDrawer } = React.useContext(CreateReviewBLContext)

  const entityType = get(entity, 'entityType')

  return (
    <DrawerModal
      width={'100%'}
      isOpen={isOpen}
      anchor={'bottom'}
      sx={{ zIndex: 1300 }}
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}
      contentWrapperStyles={WRAPPER_STYLES}>
      <Header>
        <span>{`Reviewing ${getEntityDescription(entity)}`}</span>
        <EntityDescription>{get(entity, 'description')}</EntityDescription>
        {isReviewUpdate && <UpdateIndicator>UPDATING REVIEW</UpdateIndicator>}
        <ReviewDate>
          {`${moment(get(review, 'startPeriod')).format('D MMM Y')} to ${moment(get(review, 'endPeriod')).format(
            'D MMM Y'
          )}`}
        </ReviewDate>
        <IconWrapper>
          <CloseRoundedIcon onClick={handleCloseDrawer} />
        </IconWrapper>
      </Header>
      <Wrapper>
        <ReviewDetails />
        <RightSidebar>
          {entityType === ENTITIES.PLAN && <PlanDetailsContainer />}
          {entityType === ENTITIES.PLAN_OBJECTIVE && <ObjectiveDetails entity={entity} />}
          {entityType === ENTITIES.PLAN_ACTION && <ActionDetails entity={entity} />}
          {entityType === ENTITIES.PLAN_KPI && <KPIDetails entity={entity} />}
        </RightSidebar>
      </Wrapper>
    </DrawerModal>
  )
}

export default CreateReviewDrawer
